import { useSyncExternalStore } from 'react'
import { Icon } from '@/components/brand/Brand'
import { useMotion } from '@/components/motion/motion'
import { cx } from '@/lib/cx'

/* "Back to top", bottom right (the cookie banner takes bottom left). It appears past the second
   screen, which on Home and How it works, paged a screen at a time, is the third scroll. */

const isFarDown = () => window.scrollY > (window.innerHeight || 800) * 1.5

const subscribe = (onChange: () => void) => {
  window.addEventListener('scroll', onChange, { passive: true })
  window.addEventListener('resize', onChange)
  return () => {
    window.removeEventListener('scroll', onChange)
    window.removeEventListener('resize', onChange)
  }
}

export const BackToTop = () => {
  const { reduceMotion } = useMotion()
  const shown = useSyncExternalStore(subscribe, isFarDown, () => false)

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' })
    // Keyboard users carry on from the top of the page too.
    document.querySelector<HTMLElement>('.nav-brand')?.focus({ preventScroll: true })
  }

  return (
    <button type="button" className={cx('to-top glass', shown && 'is-shown')} onClick={toTop} inert={!shown}>
      <Icon name="arrow" />
      <span className="to-top-label">Back to top</span>
    </button>
  )
}
